import * as CryptoJS from 'crypto-js';

export class IO {

  static EncodeData(content: any, asBlob?: boolean): string | Blob {
    const data = JSON.stringify(content);
    const key = CryptoJS.MD5(data).toString();
    const encrypted = '' + key + CryptoJS.AES.encrypt(data, key);
    const blob = new Blob([encrypted], { type: "octet/stream" });
    if (asBlob === true) return blob;
    const url = window.URL.createObjectURL(blob);
    return url;
  }
  static ReadSavedData(savedData: any, enc: boolean = false) {
    let data: any = savedData;
    let hash = '';
    if (enc === true) {
      if (savedData instanceof ArrayBuffer) {
        let parsed = '';
        (new Uint8Array(savedData)).forEach(function (byte: number) {
          parsed += String.fromCharCode(byte);
        });
        hash = parsed.substring(0, 32);
        data = parsed;
      }
      data = CryptoJS.AES.decrypt(data.substring(32), hash).toString(CryptoJS.enc.Utf8);
    }
    console.log(data);
    return JSON.parse(data);
  }
  MakeSaveable(savedData: string, enc?: boolean, asBlob?: boolean) {
    let out: any = savedData;
    if (enc === true) {
      var hash = CryptoJS.MD5(out).toString();
      out = '' + hash + CryptoJS.AES.encrypt(out, hash);

    }
    out = new Blob([out], { type: "octet/stream" });
    if (asBlob === true) return out;
    let url = window.URL.createObjectURL(out);
    return url;
  }
}
